"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDocumento = exports.formatCodigoCliente = exports.checkCodigoAbitab = exports.generarCodigoAbitab = void 0;
function generarCodigoAbitab(talonAbitab) {
    // Genero codigo 23 caracteres
    const codigo = [
        talonAbitab.codigoEmpresa.toString().padStart(3, "0"),
        talonAbitab.documentoCliente.toString().padStart(12, "0"),
        talonAbitab.tipoDocumentoCliente.toString(),
        talonAbitab.numeroDocumento.toString().padStart(7, "0") // 7
    ].join("");
    // Vector base 23 carac
    //1)  Corresponder cada posición numérica del string total del documento a utilizar para el código de barras, con el vector que se muestra debajo.
    const vectorBase = "73298763445632732987634";
    //2)   Multiplicar cada posición de la cadena por cada posición del vector ubicada debajo, de acuerdo al punto 1). Calcular el Módulo 10 del resultado de cada multiplicación, es decir, obtener el resto de dividir cada uno de los resultados de la multiplicación entre 10.
    //3) Sumar todos estos resultados (restos) del paso anterior entre sí.
    let suma = 0;
    for (let i = 3; i < 23; i++) {
        // Comienza en la pos 4
        const digito = parseInt(codigo[i], 10);
        const ponderacion = parseInt(vectorBase[(i - 3) % vectorBase.length], 10);
        const multiplicacion = (digito * ponderacion) % 10;
        suma += multiplicacion;
    }
    //4) Calcular el Módulo 10 del resultado obtenido en el paso 3 (obtener el resto de dividir el resultado del punto anterior entre 10).
    const modulo10Suma = suma % 10;
    //5) Restarle a 10 el resultado del paso anterior (complemento a 10 al resultado del paso 4 => 10 – resultado paso 4)
    const complementoA10 = 10 - modulo10Suma;
    //6) Si el resultado obtenido en el paso anterior no es 10, dicho valor será el dígito de control, de lo contrario el mismo será 0. Esto es equivalente a calcular nuevamente el Módulo 10 a dicho resultado (resto de dividir el valor obtenido en el punto 5 entre 10).
    const digitoControl = complementoA10 === 10 ? 0 : complementoA10;
    return codigo + digitoControl.toString();
}
exports.generarCodigoAbitab = generarCodigoAbitab;
function checkCodigoAbitab(params) {
    const { codigoEmpresa, documentoCliente, tipoDocumentoCliente, numeroDocumento } = params;
    // ** Formateo de valores **
    const documentoClienteFormateado = formatCodigoCliente(documentoCliente);
    const documentoFormateado = formatDocumento(numeroDocumento);
    // Validaciones
    if (codigoEmpresa.length != 3) {
        return new Error("El código de la empresa debe tener 3 caracteres.");
    }
    if (documentoClienteFormateado.length != 12) {
        return new Error("El número de documento del cliente debe tener 12 caracteres.");
    }
    if (documentoFormateado.length != 7) {
        return new Error("El número de documento debe tener 7 caracteres.");
    }
    // Si las validaciones pasan, se crea el objeto TalonAbitab
    const talonAbitab = {
        codigoEmpresa: codigoEmpresa,
        documentoCliente: documentoClienteFormateado,
        tipoDocumentoCliente: tipoDocumentoCliente,
        numeroDocumento: documentoFormateado
    };
    try {
        const codigoGenerado = generarCodigoAbitab(talonAbitab);
        return codigoGenerado;
    }
    catch (error) {
        return new Error("Error generando el código Abitab.");
    }
}
exports.checkCodigoAbitab = checkCodigoAbitab;
/**
 * @param {string} codigoCliente El documento del cliente
 * @return {string} Devuelve el documento del cliente como un string de 7 caracteres, agregando ceros a la izquierda si es necesario
 */
function formatCodigoCliente(codigoCliente) {
    return codigoCliente.padStart(12, "0");
}
exports.formatCodigoCliente = formatCodigoCliente;
/**
 * @param {string} documento nro documento
 * @return {string} Devuelve el nro de documento como un string de 7 caracteres, agregando ceros a la izquierda si es necesario
 */
function formatDocumento(documento) {
    return documento.padStart(7, "0");
}
exports.formatDocumento = formatDocumento;
